import { Typography } from '@mui/material';
import type { MiseSellerGroupNode } from '@/lib/types/mise/seller';

/** 店舗の所属を「全店 > 東北エリア > 宮城」の形で表示する */
export function SellerGroupPathLabel({ path }: { path: MiseSellerGroupNode[] }) {
  if (path.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        所属なし
      </Typography>
    );
  }
  return (
    <Typography variant="body2">{path.map((node) => node.name || node.id).join(' > ')}</Typography>
  );
}
